var angular = require('angular')
var moment = require('moment')
var FileSaver = require('file-saver')
require('../../filters/upper-file-extension.filter.js')
require('../../services/transparent-account.service.js')
require('../../services/app.dataservice.js')

angular.module('AemTransparentAccount')
  .component('results', {
    template: require('./results.component.tpl.html'),
    controller: ResultsCmpCtrl,
    controllerAs: 'vm',
    bindings: {}
  })

ResultsCmpCtrl.$inject = ['appLoader', 'transparentAccountService', '$routeParams', '$q', 'textToolsService', 'contentService', '$timeout', 'appDataservice']

function ResultsCmpCtrl (appLoader, transparentAccountService, $routeParams, $q, textToolsService, contentService, $timeout, appDataservice) {
  var vm = this

  vm.$onInit = function () {
    vm.accId = $routeParams.accId
    vm.filter = {
      dateFrom: null,
      dateTo: null
    }
    vm.paging = {
      page: 0,
      size: 20
    }
    vm.order = {
      name: 'processingDate',
      direction: 'DESC'
    }
    vm.recordCount = 0
    vm.viewSize = 0
    vm.setDate = setDate
    vm.setFilter = setFilter
    vm.clearFilter = clearFilter
    vm.next = next
    vm.currentDate = moment(new Date()).startOf('day').toDate()
    vm.accDetail = {}
    vm.getOrderClass = getOrderClass
    vm.setOrder = setOrder
    vm.statements = []
    vm.download = download
    vm.scrollToTable = scrollToTable

    appLoader.showImmediate()
    $q.all([
      getAccDetail(),
      getTransactions()
    ]).finally(function () {
      appLoader.hide()
      $timeout(function () {
        document.querySelector('[data-widget="AemTransparentAccount"]').scrollIntoView(true)
      })
    })

    $timeout(function () {
      angular.element('#table--sticky--header').stickyTableHeaders()
    })
  }

  function getAccDetail () {
    return transparentAccountService.accountDetail(vm.accId)
      .then(function (res) {
        vm.accDetail = res.data
        vm.accDetail.displayValue = [vm.accDetail.name, vm.accDetail.accountNumber + '/' + vm.accDetail.bankCode]
          .reduce(function (acc, cur) {
            return cur ? acc.concat(cur) : acc
          }, [])
          .join(', ')
        vm.statements = res.data.statements.map(function (item) {
          return {
            objectName: item,
            isDownloadError: false
          }
        })
      })
      .catch(function (err) {
        appDataservice.state.backendError = err
      })
  }

  function getTransactions (append) {
    if (!append) {
      vm.paging = {
        page: 0,
        size: 20
      }
    }

    var fulltext = ''
    if (vm.filter.fulltext) {
      fulltext = textToolsService.removeDiacritics(vm.filter.fulltext)
    }
    var params = {
      dateFrom: vm.filter.dateFrom && moment(vm.filter.dateFrom).format('YYYY-MM-DD'),
      dateTo: vm.filter.dateTo && moment(vm.filter.dateTo).format('YYYY-MM-DD'),
      filter: fulltext || null,
      page: vm.paging.page,
      size: vm.paging.size,
      sort: 'processingDate',
      order: vm.order.direction
    }

    appLoader.show()
    return transparentAccountService.accountTransaction(vm.accId, params)
      .then(function (response) {
        if (append) {
          vm.viewSize += response.data.transactions.length
          vm.transactions = vm.transactions.concat(response.data.transactions)
        } else {
          vm.viewSize = response.data.transactions.length
          vm.transactions = response.data.transactions
        }

        vm.page = response.data.pageNumber
        vm.recordCount = response.data.recordCount

        if (response.data.nextPage) {
          vm.showMore = true
        } else {
          vm.showMore = false
        }
      })
      .catch(function (err) {
        appDataservice.state.backendError = err
      })
      .finally(function () {
        appLoader.hide()
      })
  }

  function setDate () {
    if (vm.filter.dateFrom > vm.filter.dateTo) {
      vm.filter.dateTo = vm.filter.dateFrom
    }
    getTransactions()
  }

  function setFilter () {
    getTransactions()
  }

  function next () {
    vm.paging.page++
    getTransactions(true)
  }

  function clearFilter () {
    vm.filter = {
      dateFrom: null,
      dateTo: null
    }
    getTransactions()
  }

  function scrollToTable () {
    document.getElementById('table--sticky--header').scrollIntoView({ behavior: 'smooth' })
  }

  function getOrderClass (orderName) {
    var orderClass = null

    if (vm.order.name === orderName) {
      if (vm.order.direction === 'ASC') {
        orderClass = 'tablesort-asc'
      }
      if (vm.order.direction === 'DESC') {
        orderClass = 'tablesort-desc'
      }
    }

    return orderClass
  }

  function setOrder (orderName, defaultDirection) {
    if (vm.order.name === orderName) {
      vm.order.direction = vm.order.direction === 'ASC' ? 'DESC' : 'ASC'
    } else {
      vm.order.name = orderName
      vm.order.direction = defaultDirection
    }
    getTransactions()
  }

  function download (statement) {
    statement.isDownloadError = false
    contentService.getStaticBlob('internet', statement.objectName).promise
      .then(function (res) {
        FileSaver.saveAs(res.data, statement.objectName, 'application/' + statement.objectName.split('.').reverse()[0])
      })
      .catch(function () {
        statement.isDownloadError = true
      })
  }
}
